/* Fetch helpers for the projects bundle's own writes (project save, charter
   save, demand save), ported VERBATIM from app.ts (failureReason ~ / SAVE_FAILED
   ~2955). The store keeps these module-private, and the projects bundle is
   forbidden from editing the store, so the same pure helpers live here — the
   endpoints, methods, and bodies the views send stay byte-identical to the
   vanilla client (the API contract is frozen). */

export const SAVE_FAILED = "Save failed — is the server healthy?";

function unauthoredReason(status: number | undefined, fallback: string): string {
  const action = fallback.split(" — ")[0];
  if (status === 401 || status === 403)
    return `${action} — the request was refused before it reached the app; reload the page to sign in again. (HTTP ${status})`;
  return status === undefined ? fallback : `${fallback} (HTTP ${status})`;
}

export async function failureReason(
  res: { status?: number; json(): Promise<unknown> },
  fallback: string,
): Promise<string> {
  try {
    const { error } = (await res.json()) as { error?: string };
    if (error) return error;
  } catch {
    /* no readable body — fall through to the status */
  }
  return unauthoredReason(res.status, fallback);
}

export const savedNotRedrawn = (what: string): string =>
  `Saved ${what} — but the page couldn't be redrawn. Reload to see it.`;
